module.exports = __webpack_public_path__ + "static/media/no_address2x.c784b213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/no_address2x.png
// module id = 1111
// module chunks = 50